import React from 'react';
import { useState, useRef } from 'react';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { Trans } from '@lingui/macro';
import { EStatisticsType } from '../../../../reducers/data';
import SmallTypeTitle from '../statistics/SmallTypeTitle';

interface IProps {
    selected: EStatisticsType,
    allowed: EStatisticsType[],
    onSelect: (type: EStatisticsType) => void
}

const FilterGraphType: React.FC<IProps> = (props) => {
    const ref = useRef<HTMLDivElement>(null)
    
    const [show, setShow] = useState(false)
    
    useOnClickOutside(ref, () => {
        setShow(false)
    })

    let graphs: {
        image: string,
        type: EStatisticsType
    }[] = []

    if(props.allowed.includes(EStatisticsType.column)) {
        graphs.push({
            image: '/assets/layout/t3.png',
            type: EStatisticsType.column
        })
    }
    
    if(props.allowed.includes(EStatisticsType.cake)) {
        graphs.push({
            image: '/assets/layout/t2.png',
            type: EStatisticsType.cake
        })
    }
    
    if(props.allowed.includes(EStatisticsType.xy)) {
        graphs.push({
            image: '/assets/layout/t1.png',
            type: EStatisticsType.xy
        })
    }
    
    if(props.allowed.includes(EStatisticsType.table)) {
        graphs.push({
            image: '/assets/layout/t4.png',
            type: EStatisticsType.table
        })
    }
    
    return (
        <div className={`element_drop basic to_center col_default offset ${show?'active':''}`} ref={ref}>
            <button 
                type="button" 
                className="btn_basic element_drop_button"
                onClick={() => {
                    setShow(!show)
                }}
            >
                <span><Trans>Typ</Trans></span>
                <svg className="sico drop"><use xlinkHref="/assets/layout/icons.svg#s_ar1_d" /></svg>
            </button>  
            <div className="element_drop_inner">
                <div className="element_drop_arrow"></div>
                <div className="element_drop_content pd-30 pdt-10">
                    <div className="grid flex-nowrap-md">
                        {graphs.map((g,i) => (
                            <label key={i} className="item_image_label col_equal offset wmin190 wmin150_xlm wmin100_mdm">
                                <input 
                                    type="radio" 
                                    name={"graph_" + g.type} 
                                    checked={props.selected === g.type}
                                    onChange={(e) => {
                                        if(e.target.checked) {
                                            props.onSelect(g.type)
                                        }
                                        setShow(false)
                                    }}
                                />
                                <div className="item_image">
                                    <img src={g.image} alt={g.type} className="item_image_img" />
                                    <div className="item_image_desc">
                                        <span><Trans>Typ</Trans></span>
                                        <strong><SmallTypeTitle type={g.type}/></strong>
                                    </div>
                                </div>
                            </label>
                        ))}
                    </div>
                </div>
            </div>                       
        </div> 
    )
}

export default FilterGraphType